import { useState } from 'react';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { FEATURED_ARENAS } from 'modules/jogador/home/content';
import { searchArenas, toFeaturedArena } from 'modules/jogador/home/arenaSearchService';
import { useArenaProfile } from 'shared/contexts/ArenaProfileContext';

export function useArenaSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [sportId, setSportId] = useState('todos');

  const { profile, isCustom } = useArenaProfile();
  // A arena cadastrada na demonstração entra no marketplace junto com as parceiras.
  const ownArena = isCustom ? toFeaturedArena(profile) : null;

  const { data: filteredArenas, isLoading, error } = useAsyncData(
    () => searchArenas({ searchTerm, sportId }, ownArena),
    FEATURED_ARENAS,
    [searchTerm, sportId, ownArena?.name]
  );

  return { searchTerm, setSearchTerm, sportId, setSportId, filteredArenas, isLoading, error };
}
